import React, { useEffect, useState } from "react";

// project-import
import { showToast } from "../../components/sweet-alert/Sweetalert";
import { useCoursesContext } from "../../context/courses_context";
import { GoogleAnalyticsEnum, pageView } from "../../utils/google-analytics";
import SEO from "../../common/SEO";
import FooterOne from "../../common/footer/FooterOne";
import SalesforceBlog from "../../components/salesforce/SalesforceBlog";
import SalesforceAbout from "../../components/salesforce/SalesforceAbout";
import BannerSalesforce from "../../components/banner/BannerSalesforce";
import HeaderLandingPage from "../../common/header/HeaderLandingPage";
import SalesforceCourses from "../../components/salesforce/SalesforceCourses";
import SalesforceCategory from "../../components/salesforce/SalesforceCategory";
import SaleforceWhyChooseUs from "../../components/salesforce/SaleforceWhyChooseUs";
import SalesforceNewsLettter from "../../components/newsletter/SalesforceNewsLettter";
import TestimonialSectionSalesforce from "../../components/testimonial-section/TestimonialSectionSalesforce";
import HeaderOne from "../../common/header/HeaderOne";
import HeaderTwo from "../../common/header/HeaderTwo";
import HeaderSticky from "../../common/header/HeaderSticky";
import ConsultationCallToAction from "../../components/cta/ConsultationCallToAction";
import TestimonialSectionSalesforceV2 from "../../components/testimonial-section/TestimonialSectionSalesforceV2";
import SalesforceEbook from "../../components/salesforce/SalesforceEbook";
import SalesforceOffering from "../../components/salesforce/SalesforceOffering";
import { useParams } from "react-router-dom";
import { useProductContext } from "../../context/product_context";
import HomeFourBlog from "../../components/home-four/HomeFourBlog";
import { useGalleryContext } from "../../context/gallery_context";
import TestimonialSectionThree from "../../components/testimonial-section/TestimonialSectionThree";
import { useTestimonialContext } from "../../context/testimonial_context";
import HomeFiveBlog from "../../components/home-five/HomeFiveBlog";
import InterviewQuestionHome from "../../components/interview-questions/InterviewQuestionHome";
import BannerSix from "../../components/banner/BannerSix";
import SalesforceEbookV2 from "../../components/salesforce/SalesforceEbookV2";
import SalesforceKnowledgeCard from "../../components/salesforce/SalesforceKnowledgeCard";
import { useBlogContext } from "../../context/blog_context";

// Reading environment variable start
const SALESFORCE_COURSE_DOMAIN = process.env.REACT_APP_SALESFORCE_COURSE_DOMAIN;
// Reading environment variable end

const Salesforce = (props) => {

  // Reading store data
  const { fetchCourses, setFilteredCourses } = useCoursesContext();
  const { blogLoading } = useBlogContext();

  const [coursesDomain] = useState(SALESFORCE_COURSE_DOMAIN);

  // Extracting variables from context
  const { galleryData, galleryLoading } = useGalleryContext();
  const { ebooks, productLoading } =
    useProductContext();

  // State variable initialization
  const [stencilLoading, setStencilLoading] = useState(true);

  // Loading timeout
  setTimeout(() => {
    setStencilLoading(false);
  }, 1000);

  useEffect(() => {
    try {
      fetchCourses(coursesDomain);
    } catch (error) {
      console.log("44 : Salesforce : Error occurred while fetching courses for domain:", coursesDomain, error && JSON.stringify(error));

      showToast("error", "Oops! Something went wrong while fetching the courses. Please try again later.", true, "bottom-right", false, true, 5000);
    }
  }, []);

  const dataCloudSeriesData = (galleryData || []).filter(i => i?.playlistName === "Salesforce Data Cloud Series") || [];
  const ytLiveSessionsData = (galleryData || []).filter(i => i?.playlistName === "Salesforce Live") || [];

  const allEBooks = ebooks && ebooks?.length ? ebooks : [];

  return (
    <>
      <SEO /> {/* Set SEO title */}
      {pageView(
        window.location.pathname,
        GoogleAnalyticsEnum.SALESFORCE_COURSE_HOME
      )}

      {/* Header component */}
      {/* <HeaderTwo styles="header-transparent header-style-2" /> */}
      {/* <HeaderLandingPage styles="header-transparent" setFilteredCourses={setFilteredCourses} stencilLoading={stencilLoading} searchDisable={false} /> */}
      {/* <HeaderOne /> */}
      <HeaderTwo searchDisable={true} />
      {/* <HeaderSticky /> */}

      {/* Banner component */}
      {/* <BannerOne /> */}
      {/* <BannerSalesforce stencilLoading={stencilLoading} /> */}
      <BannerSix stencilLoading={stencilLoading} />

      {/* E-Book component */}
      {/* <SalesforceEbook isFromHome={true} stencilLoading={stencilLoading} /> */}

      {/* <SalesforceEbookV2 data={freeEBooksData} title="Salesforce Learning Resources Library" subTitle="Curated Salesforce Free E-Books" activeStatus={FREE} isFromHome={true} stencilLoading={stencilLoading} productLoading={productLoading} /> */}

      <SalesforceEbookV2 data={allEBooks} subText="Salesforce Learning Resources Library" title="Curated E-Books" isFromHome={true} productLoading={productLoading} />

      {/* Knowledge Card */}
      <SalesforceKnowledgeCard isLoading={blogLoading} />

      {/* News letter component*/}
      {/* <SalesforceNewsLettter stencilLoading={stencilLoading} /> */}
      {/* <ConsultationCallToAction stencilLoading={stencilLoading} /> */}

      {/* About component */}
      {/* <SalesforceAbout stencilLoading={stencilLoading} /> */}

      {/* Category component */}
      {/* <SalesforceCategory stencilLoading={stencilLoading} /> */}



      {/* Consultation call to action component*/}
      <ConsultationCallToAction stencilLoading={stencilLoading} />

      {/* Courses component */}
      {/* <SalesforceCourses stencilLoading={stencilLoading} /> */}

      {/* Interview-questions Categories */}
      <InterviewQuestionHome stencilLoading={stencilLoading} />

      {/* Salesforce DataCloud videos component */}
      {/* <HomeFourBlog data={dataCloudSeriesData} title="Salesforce Data Cloud" subTitle="Beginner to Advanced" isShowYtVideo={true} videoType="short" stencilLoading={stencilLoading} classes="eduvibe-home-one-blog bg-image" /> */}


      {/** User Reviews section */}
      {/* <TestimonialSectionSalesforceV2 stencilLoading={stencilLoading} /> */}

      {/* Testimonial component */}
      {/* <TestimonialSectionThree stencilLoading={stencilLoading} /> */}

      {/* Pricing component */}
      <SalesforceOffering stencilLoading={stencilLoading} />

      {/* Salesforce Live videos component */}
      <HomeFourBlog data={ytLiveSessionsData} title="Salesforce Live Streams" subTitle="Live Sessions On YouTube" isShowYtVideo={true} videoType="video" galleryLoading={galleryLoading} stencilLoading={stencilLoading} classes="background-img-none bg-color-white" />

      {/* Blog component */}
      {/* <SalesforceBlog stencilLoading={stencilLoading} /> */}

      {/* Salesforce Related News component */}
      {/* <HomeFiveBlog stencilLoading={stencilLoading} /> */}


      {/* About component */}
      {/* <SalesforceAbout stencilLoading={stencilLoading} /> */}

      {/* News letter component*/}
      {/* <SalesforceNewsLettter stencilLoading={stencilLoading} /> */}

      {/* Testimonial component */}
      {/* <TestimonialSectionSalesforce stencilLoading={stencilLoading} /> */}

      {/* Instructor component */}
      {/* <SalesforceInstructor /> */}

      {/* Video section component */}
      {/* <VideoSectionTwo /> */}

      {/* Why choose us component */}
      {/* <SaleforceWhyChooseUs stencilLoading={stencilLoading} /> */}

      {/* Footer component */}
      <FooterOne stencilLoading={stencilLoading} />
    </>
  );
};

export default Salesforce;
